module.exports = __webpack_public_path__ + "img/hr-dead-tree-desert-07.dfd838f1.png";